"use strict";

require("core-js/modules/es6.object.define-property");

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./proptypes"));

__export(require("./colors"));